import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Compass } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { PAGES, langPath } from '../../utils/siteNav';
import { guideLabels } from '../../i18n/guides/meta';

// Home-page grid that sends visitors to each section's own page.
export default function SectionTeasers({ exclude = ['rooms'] }) {
  const { language, t } = useLanguage();
  const gl = guideLabels(language);
  const pages = [...PAGES.filter((p) => !exclude.includes(p.slug)), { slug: 'guides', icon: Compass, label: gl.title, teaser: gl.sub }];
  return (
    <section className="py-24 bg-slate-50" data-testid="section-teasers">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12 max-w-2xl">
          <span className="text-amber-700 font-medium tracking-widest text-sm uppercase">{t('pages.discover')}</span>
          <h2 className="text-3xl md:text-4xl font-serif text-slate-800 mt-3">{t('pages.discoverSub')}</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {pages.map((p, i) => {
            const Icon = p.icon;
            const copy = p.teaser ? { title: p.label, teaser: p.teaser } : t(`pages.${p.slug}`);
            return (
              <Link key={p.slug} to={langPath(language, p.slug)} className="group relative bg-white rounded-2xl border border-slate-200 p-6 flex flex-col gap-4 hover:border-amber-400 hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow,border-color] duration-300" style={{ animationDelay: `${i * 60}ms` }} data-testid={`teaser-${p.slug}`}>
                <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center group-hover:bg-amber-600 group-hover:text-white transition-colors duration-300"><Icon className="w-6 h-6" /></div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-slate-800">{typeof copy === 'object' ? copy.title : p.label}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{typeof copy === 'object' ? copy.teaser : ''}</p>
                </div>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-700">{t('pages.open')} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" /></span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
